<template>
  <StandardSearchPageView
    ref="tableWrap"
    rowKey="id"
    :columns="columns"
    :queryParams="queryParams"
    :searchOptions="searchOptions"
    :request-promise="loadList"
    :show-reset-button="true"
  >
    <template v-slot:statusText="{ record }">
      {{ record.statusDesc || (Number(record.status) === 1 ? '发送成功' : '发送失败') }}
    </template>

    <template v-slot:action="{ record }">
      <a @click="toggleStatus(record)">
        {{ Number(record.status) === 1 ? '禁用' : '启用' }}
      </a>
    </template>
  </StandardSearchPageView>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'SendRecordTab',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {
        phoneNumbers: '',
        status: undefined
      },
      searchOptions: [
        {
          name: '手机号',
          key: 'phoneNumbers',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '状态',
          key: 'status',
          type: 'select',
          placeholder: '请选择',
          selectOptions: [
            { label: '发送成功', value: 1 },
            { label: '发送失败', value: 0 }
          ]
        }
      ],
      columns: [
        { title: 'ID', dataIndex: 'id', width: 180 },
        { title: '短信内容', dataIndex: 'content', width: 360 },
        { title: '发送手机号', dataIndex: 'phoneNumbers', width: 140 },
        { title: '发送时间', dataIndex: 'createTime', width: 180 },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusText' },
          width: 110
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' },
        //   // className: 'sticky-action-column',
        //   fixed: 'right',
        //   width: 100
        // }
      ]
    }
  },
  methods: {
    loadList(requestParams) {
      const { limitDto, phoneNumbers, status } = requestParams
      return this.getHttpServices().getNewServeService().post('/smsRecord/page', {
        limitDto,
        phoneNumbers: phoneNumbers || '',
        status
      })
    },
    toggleStatus(record) {
      record.status = Number(record.status) === 1 ? 0 : 1
      this.$message.success(Number(record.status) === 1 ? '已启用' : '已禁用')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
